var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.875C11.4665 14.875 12.25 15.6585 12.25 16.625C12.25 17.5915 11.4665 18.375 10.5 18.375C9.53347 18.375 8.75 17.5915 8.75 16.625C8.75 15.6585 9.53347 14.875 10.5 14.875Z",
    fill: "#094A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.75C11.4665 8.75 12.25 9.53348 12.25 10.5C12.25 11.4665 11.4665 12.25 10.5 12.25C9.53347 12.25 8.75 11.4665 8.75 10.5C8.75 9.53348 9.53347 8.75 10.5 8.75Z",
    fill: "#094A73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.625C11.4665 2.625 12.25 3.40848 12.25 4.375C12.25 5.34153 11.4665 6.125 10.5 6.125C9.53347 6.125 8.75 5.34153 8.75 4.375C8.75 3.40848 9.53347 2.625 10.5 2.625Z",
    fill: "#094A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.a3e3e339f93e7135746faca0dd75519a.svg";
export { ForwardRef as ReactComponent };